import {Component, OnInit} from '@angular/core';
import {Meetings} from '../home/components/meetings/meetings.interface';
import {
  ClientDetails,
  DashboardDetails,
  InnovationAndProductivity,
} from '../../interfaces/home.interface';
import {ActivatedRoute, Router} from '@angular/router';
import {HomeService} from 'src/app/services/home/home.service';
import {OwlOptions} from "ngx-owl-carousel-o";
import {Metric} from "../../interfaces/engagement-details.interface";
import { KeyMetricesResponse,RevenueAndMarginData,RevenueData } from '../home/components/revenue-potential/key-metrices.interface';

@Component({
  selector: 'app-engagement-details',
  templateUrl: './engagement-details.component.html',
  styleUrls: ['./engagement-details.component.scss']
})
export class EngagementDetailsComponent implements OnInit {
  loading: boolean = false;
  meetingLoading: boolean = false;
  pastMeetings: Meetings[] = [];
  public innovationAndProductivity!: InnovationAndProductivity[];
  innovationInflightLength: number = 0;
  innovationCompletedLength: number = 0;
  clientName: any = "";
  clientId: any = "";
  quickLinks: Array<any> = [
    {
      img: 'assets/images/img1.png',
      text: 'Contractual Documents',
    },
    {
      img: 'assets/images/img2.png',
      text: 'Asset Library',
    },
  ];
  upcomingMeetings: any = [{meetingDate: new Date().toISOString()}];
  initiativesTabs: Array<any> = [
    {
      activeIcon: 'assets/images/inflights_active.svg',
      inActiveIcon: 'assets/images/inflights_inactive.svg',
      name: 'Inflight',
      count: 0,
      active: true,
    },
    {
      activeIcon: 'assets/images/completed_active.svg',
      inActiveIcon: 'assets/images/completed_inactive.svg',
      name: 'Completed',
      count: 0,
      active: false,
    },
  ];
  initiativesData: Array<any> = [];
  activeInitiativeType: string = 'Inflight';
  showMetricLoader = false;
  showMetricChartLoader = false;
  carouselOptions: OwlOptions = {
    items: 4,
    margin: 10,
    loop: false,
    dots: false,
    nav: false,
    rewind: true,
    autoWidth: true,
  }
  isCarouselSlideDragging = false;
  metrics: Metric[] = [];
  selectedMetric!: Metric;
  chartData: any;
  public persona: string = '';
  

  constructor(private route: ActivatedRoute, private homeServiceRef: HomeService, private router:Router) {
  }

  ngOnInit(): void {
    this.meetingLoading = true;
    let id = this.route.snapshot.paramMap.get('id');
    let name = this.route.snapshot.paramMap.get('name');
    this.clientName = name;
    this.clientId = id;
    if (id) {
      this.homeServiceRef.setEngagementId(id);
      this.homeServiceRef.getInnovationAndProductivity(id).subscribe((res) => {
        this.innovationAndProductivity = res;
        this.initiativesData = res.filter(
          (r: InnovationAndProductivity) => r.status === 'Inflight'
        );
        this.innovationInflightLength = this.initiativesData.length;

        this.innovationCompletedLength = res.filter(
          (r: InnovationAndProductivity) => r.status === 'Completed'
        ).length;
        this.initiativesTabs.forEach((item) => {
          if (item.name == 'Inflight') {
            item.count = this.innovationInflightLength;
          }
          if (item.name == 'Completed') {
            item.count = this.innovationCompletedLength;
          }
        });
      });

      this.homeServiceRef.getGovernanceMeetings(id).subscribe((res) => {
        if (!!res) {
          this.pastMeetings = res;
          this.meetingLoading = false;
        }
      });
    }
    this.homeServiceRef.persona$.subscribe(persona => {
      this.persona = persona;
      this.getAllMetrics();
    });    
  }

  getAllMetrics(): void {
    if (this.showMetricLoader) {
      return;
    }
    this.showMetricLoader = true;
    this.homeServiceRef.getKeymetricsList(this.clientId, this.clientName).subscribe((res) => {
      this.metrics = res.metrics
        .filter((metric: string) => {
          return res.persona[metric].includes(this.persona)
        })
        .map((metric: string) => {
          return { label: metric }
        });
      this.showMetricLoader = false;
      this.showMetricChartLoader = false;
      if (this.metrics.length > 0) {
        this.onCarouselSlideItemClick(this.metrics[0]);
      }
    })

    
    // Call API here [Remove the below metrics data with the actual API response]
    // setTimeout(() => {
    //   this.metrics = [
    //     {label: "SLA"},
    //     {label: "Audit Finding"},
    //     {label: "Revenue & Margin"},
    //     {label: "Financial Accuracy"},
    //     {label: "CSAT"},
    //     {label: "Total Budget"},
    //     {label: "Business Process Improvement"},
    //     {label: "Compliance Rate"},
    //     {label: "Invoicing Status"},
    //   ]
    //   this.showMetricLoader = false;
    //   this.onCarouselSlideItemClick(this.metrics[0])
    // }, 500);
  }

  onCarouselSlideItemClick(metric: Metric): void {
    if (this.showMetricChartLoader) {
      return;
    }
    this.selectedMetric = metric;
    this.getMetricChartData();
  }

  getMetricChartData(): void {
    this.showMetricChartLoader = true;
    this.homeServiceRef.getKeymetricsDetails(this.clientId, this.clientName, this.selectedMetric.label).subscribe((res: KeyMetricesResponse) => {
      console.log(res.data);
      if (this.selectedMetric.label === "Revenue&Margin") {
        this.chartData = (res.data as RevenueAndMarginData[]).map(data => ({
          revenueGenerated: data.revenueGenerated,
          incurredCost: data.incurredCost,
          period: this.formatPeriod(data.period),
          isProjected: data.isProjected,
          clientIdentifier: res.clientIdentifier,
          marginPercentage: data.marginPercentage,
        }));
      } else {
        this.chartData = (res.data as RevenueData[]).map(data => ({
          value: data.value,
          period: this.formatPeriod(data.period),
          isProjected: data.isProjected,
        }));
      }
      this.showMetricLoader = false;
      this.showMetricChartLoader = false;
    })
    //Call API here [Remove the below mocked chart data with the actual API response ]
    // setTimeout(() => {
    //   if(this.selectedMetric.label === "Revenue & Margin"){
    //      this.chartData = [
    //        {
    //          "uId": "c8169120-618c-4456-be1d-abd45a5b8bba",
    //          "revenueGenerated": 1000000,
    //          "incurredCost": 1000000,
    //          "period": "Jan 2022",
    //          "isProjected": false,
    //          "clientIdentifier": "e298731a-69f3-482a-8251-981c623892d3",
    //          "marginPercentage": 10
    //        },
    //        {
    //          "uId": "67107b74-5255-4888-a8c4-13d7f69f80b2",
    //          "revenueGenerated": 1500000,
    //          "incurredCost": 20,
    //          "period": "Jan 2023",
    //          "isProjected": false,
    //          "clientIdentifier": "e298731a-69f3-482a-8251-981c623892d3",
    //          "marginPercentage": 20
    //        },
    //        {
    //          "uId": "67107b74-5255-4888-a8c4-13d7f69f80b2",
    //          "revenueGenerated": 2000000,
    //          "incurredCost": 3000000,
    //          "period": "Jan 2024",
    //          "isProjected": true,
    //          "clientIdentifier": "e298731a-69f3-482a-8251-981c623892d3",
    //          "marginPercentage": 25
    //        },
    //        {
    //          "uId": "67107b74-5255-4888-a8c4-13d7f69f80b2",
    //          "revenueGenerated": 2500000,
    //          "incurredCost": 3000000,
    //          "period": "Jan 2025",
    //          "isProjected": true,
    //          "clientIdentifier": "e298731a-69f3-482a-8251-981c623892d3",
    //          "marginPercentage": 30
    //        },
    //        {
    //          "uId": "67107b74-5255-4888-a8c4-13d7f69f80b2",
    //          "revenueGenerated": 4000000,
    //          "incurredCost": 2000000,
    //          "period": "Jan 2026",
    //          "isProjected": true,
    //          "clientIdentifier": "e298731a-69f3-482a-8251-981c623892d3",
    //          "marginPercentage": 35
    //        }
    //      ]
    //   }else{
    //     let chartData = [
    //       {
    //         "uId": "c8169120-618c-4456-be1d-abd45a5b8bba",
    //         "value": 1000000,
    //         "period": "Jan 2022",
    //         "isProjected": false,
    //       },
    //       {
    //         "uId": "67107b74-5255-4888-a8c4-13d7f69f80b2",
    //         "value": 1500000,
    //         "period": "Jan 2023",
    //         "isProjected": false,
    //       },
    //       {
    //         "uId": "67107b74-5255-4888-a8c4-13d7f69f80b2",
    //         "value": 2000000,
    //         "period": "Jan 2024",
    //         "isProjected": false,
    //       },
    //       {
    //         "uId": "67107b74-5255-4888-a8c4-13d7f69f80b2",
    //         "value": 2500000,
    //         "period": "Jan 2025",
    //         "isProjected": true,
    //       },
    //       {
    //         "uId": "67107b74-5255-4888-a8c4-13d7f69f80b2",
    //         "value": 4000000,
    //         "period": "Jan 2026",
    //         "isProjected": true,
    //       }
    //     ]
    //     this.chartData = [...chartData].map(item => {
    //       let value = parseInt('' + Math.random() * (500000 - 100000) + 100000);
    //       item.value = value;
    //       return item;
    //     });
    //   }
    //   this.showMetricChartLoader = false;
    // }, 1000);
  }

  private formatPeriod(dateString: string): string {
    const date = new Date(dateString);
    return date.toLocaleString('default', { month: 'short', year: 'numeric' });
  }

  onCarouselSlideDragging(event: any): void {
  //  setTimeout(() => {
  //    this.isCarouselSlideDragging = event.dragging
  //  });
  }

  tabClickHandler(tab: string): void {
    this.activeInitiativeType = tab;
    tab === 'Inflight'
      ? (this.initiativesData = this.innovationAndProductivity.filter(
        (res) => res.status === 'Inflight'
      ))
      : (this.initiativesData = this.innovationAndProductivity.filter(
        (res) => res.status === 'Completed'
      ));
    this.initiativesTabs.forEach((item) => {
      item.active = item.name === tab;
    });
  }

  onBackClickHandler(){
    let id = this.route.snapshot.paramMap.get('id');
    this.router.navigate([`/home`, id]);
  }

}
